<template>
  <div class="home-page">
    <div class="banner">
      <swiper :options="swiperOption" ref="mySwiper" v-if="images.length > 0">
        <swiper-slide v-for="(item, index) in images" :key="index">
          <div class="bg" :style="{ backgroundImage: `url(${item.src})` }" @click="handleGo(item.link)"></div>
        </swiper-slide>
      </swiper>
      <div class="swiper-pagination"></div>
    </div>

    <div class="story_wrap flex-rowl">
      <div class="logo image-container">
        <img
          :src="require('@/assets/images/about_logo.png')"
          alt=""
          class="zoomable-image"
        />
      </div>
      <div
        class="main_content flex-colc wow animate__animated animate__slideInUp"
      >
        <div class="title flex-colc f-source-han-serif-cn-M">
          <p>{{ $t('home.story.title1') }}</p>
          <p>{{ $t('home.story.title2') }}</p>
        </div>
        <div class="txt f-source-han-sans-cn-L">
          <p>{{ $t('home.story.desc1') }}</p>
          <p>{{ $t('home.story.desc2') }}</p>
          <p>{{ $t('home.story.desc3') }}</p>
        </div>
        <div class="more f-times-new-roman" @click="handleGo('/BrandPage')">
          Know More About <span>VESCOR STORY</span>...
        </div>
      </div>
    </div>

    <div class="column_one flex-between">
      <div class="img image-container">
        <img
          src="https://upload.vwingist.com/melscn/0image/2025/02/5678341120933179971.png"
          alt=""
          class="zoomable-image"
        />
      </div>
      <div
        class="main_content flex-colc wow animate__animated animate__slideInUp"
      >
        <div class="title flex-colc f-source-han-serif-cn-M">
          <p>{{ $t('home.tech.title1') }}</p>
          <p>{{ $t('home.tech.title2') }}</p>
        </div>
        <div class="txt f-source-han-sans-cn-L">
           <p>{{ $t('home.tech.desc1') }}</p>
          <p>{{ $t('home.tech.desc2') }}</p>
        </div>
        <div class="more f-times-new-roman" @click="handleGo('/TechPage')">
          Know More About <span>VESCOR STORY</span>...
        </div>
      </div>
    </div>

    <div class="column_two flex-rowc wow animate__animated animate__slideInUp">
      <div class="item flex-colc">
        <div class="thumb image-container">
          <img
            src="https://upload.vwingist.com/melscn/0image/2025/02/5717266711333166833.png"
            alt=""
            class="zoomable-image"
          />
        </div>
        <div class="content">
          <div class="txt f-source-han-serif-cn-M">{{ $t('home.features.feature1.title') }}</div>
          <p class="f-source-han-sans-cn-L">{{ $t('home.features.feature1.desc') }}</p>
        </div>
      </div>
      <div class="item flex-colc">
        <div class="thumb image-container">
          <img
            src="https://upload.vwingist.com/melscn/0image/2025/02/4996695172101454397.png"
            alt=""
            class="zoomable-image"
          />
        </div>
        <div class="content">
          <div class="txt f-source-han-serif-cn-M">{{ $t('home.features.feature2.title') }}</div>
          <p class="f-source-han-sans-cn-L">{{ $t('home.features.feature2.desc') }}</p>
        </div>
      </div>
      <div class="item flex-colc">
        <div class="thumb image-container">
          <img
            src="https://upload.vwingist.com/melscn/0image/2025/02/5693061968312466750.png"
            alt=""
            class="zoomable-image"
          />
        </div>
        <div class="content">
          <div class="txt f-source-han-serif-cn-M">{{ $t('home.features.feature3.title') }}</div>
          <p class="f-source-han-sans-cn-L">{{ $t('home.features.feature3.desc') }}</p>
        </div>
      </div>
    </div>

    <!-- 产品展示 start -->
    <div class="product_wrap">
      <div class="title flex-colc wow animate__animated animate__slideInUp">
        <p class="txt1 f-source-han-serif-cn-M">{{ $t('home.product.title1') }}</p>
        <p class="txt2 f-times-new-roman">{{ $t('home.product.title2') }}</p>
        <p class="txt3 f-source-han-serif-cn-M">{{ $t('home.product.title3') }}</p>
      </div>
      <div class="column_three flex-between">
        <div
          class="main_content flex-colc wow animate__animated animate__slideInUp"
        >
          <div class="title flex-colc f-source-han-serif-cn-M">
            <p>{{ $t('home.product.philosophy1') }}</p>
            <p>{{ $t('home.product.philosophy2') }}</p>
          </div>
          <div class="txt f-source-han-sans-cn-L">
            <p>{{ $t('home.product.philosophyDesc1') }}</p>
            <p>{{ $t('home.product.philosophyDesc2') }}</p>
            <p>{{ $t('home.product.philosophyDesc3') }}</p>
            <p>{{ $t('home.product.philosophyDesc4') }}</p>
          </div>
          <div class="more f-times-new-roman" @click="handleGo('/ProductCatalog')">
            Know More About <span>VESCOR STORY</span>...
          </div>
        </div>
        <div class="img image-container">
          <img
            src="https://upload.vwingist.com/melscn/0image/2025/04/5231633919529876518.png"
            alt=""
            class="zoomable-image"
          />
        </div>
      </div>
      <div class="product-swiper-container flex-between">
        <div class="swiper-wrap">
          <swiper :options="swiperOption1" v-if="products.length > 0">
            <swiper-slide
              v-for="(item, index) in products"
              :key="index"
              class="swiper-slide"
            >
              <div class="thumb image-container" @click="handleGo(item.link)">
                <img :src="item.image" alt="" class="zoomable-image" />
              </div>
              <div class="main">
                <div class="content">
                  <div class="title flex-colc f-source-han-serif-cn-M">
                    <p>{{ $t(`home.product.descriptions.${item.titKey}`) }}</p>
                    <p v-html="item.subTitle"></p>
                  </div>
                  <div class="txt" v-html="$t(`home.product.descriptions.${item.txtKey}`)"></div>
                  <div class="des" v-html="item.des"></div>
                </div>
                <div class="more flex-rowc f-source-han-sans-cn-L" @click="handleGo(item.link)">
                   {{ $t('home.product.productMore') }}
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
        <!-- 如果需要导航按钮 -->
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
      </div>
    </div>
    <!-- 产品展示 end -->

    <div class="join_wrap">
      <!-- <div class="img">
        <img :src="require('@/assets/images/join_bg.png')" alt="" />
      </div> -->
      <div class="content flex-colc wow animate__animated animate__slideInUp">
        <div class="title">
          <p class="txt1 f-times-new-roman">{{ $t('join.title1') }}</p>
          <p class="txt2 f-source-han-serif-cn-M">{{ $t('join.title2') }}</p>
          <p class="txt3 f-source-han-serif-cn-M">{{ $t('join.title3') }}</p>
        </div>
        <div class="txt">
          <p>{{ $t('join.desc1') }}</p>
          <p>{{ $t('join.desc2') }}</p>
        </div>
        <div class="more flex-rowc" @click="handleGo('ProductPage')">{{ $t('join.more') }}</div>
      </div>
    </div>

    <!-- 底部装饰 -->
    <!-- <div class="footer_wrap">
      <div class="img">
        <img :src="require('@/assets/images/footer_bg.png')" alt="" />
      </div>
    </div> -->
  </div>
</template>
<script>
// 引入文件
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  name: "Home",
  //import引入的组件需要注入到对象中才能使用
  components: { swiper, swiperSlide },
  data() {
    return {
      swiperOption: {
        autoplay: {
          //自动开始
          delay: 2000, //时间间隔
          disableOnInteraction: false, //*手动操作轮播图后不会暂停*
        },
        loop: true,
        initialSlide: 0, //初始化页码
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      images: [
        {
          src: "https://upload.vwingist.com/melscn/0image/2025/04/4928453718253118167.jpeg",
          link: '/ProductDetailPage/detail5',
        },
        {
          src: "https://upload.vwingist.com/melscn/0image/2025/04/4709085911163502024.jpeg",
          link: '/ProductDetailPage/detail3',
        },
        {
          src: "https://upload.vwingist.com/melscn/0image/2025/04/5582600406123063430.jpg",
          link: '/ProductDetailPage/detail7',
        },
        {
          src: "https://upload.vwingist.com/melscn/0image/2025/04/4687765703616027497.jpg",
          link: '/ProductDetailPage/detail6'
        },
        {
          src: "https://upload.vwingist.com/melscn/0image/2025/04/4755413188182329575.jpg",
          link: '/ProductDetailPage/detail2'
        },
        {
          src: "https://upload.vwingist.com/melscn/0image/2025/04/4992780472102373969.jpg",
          link: '/ProductDetailPage/detail1'
        },
        {
          src:  "https://upload.vwingist.com/melscn/0image/2025/04/4799192357546708325.jpeg",
          link: '/ProductDetailPage/detail4'
        } 
        // 可以继续添加更多图片路径
      ],

      swiperOption1: {
        slidesPerView: 3, // 每屏显示 4 个滑块
        centeredSlides: false, // 中间滑块居中显示
        spaceBetween: 15, // 滑块之间的间距
        slidesPerGroup: 1, // 每次滑动的滑块数量
        loop: false, // 是否循环播放
        autoplay: {
          delay: 15000, // 自动播放时间间隔
          disableOnInteraction: false, // 用户操作后是否停止自动播放
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      products: [
        {
          image:
            "https://upload.vwingist.com/melscn/0image/2025/04/4723240614122955515.jpg",
          title: "彈力賦活精華水",
          titKey: "product1",
          subTitle: "",
          txt: "「VESCOR魔法1+1」，抗氧化第一步<br>開啟醣化狙擊戰。",
          txtKey: "product1Desc",
          des: "",
          link: "/ProductDetailPage/detail3",
        },
        {
          image:
            "https://upload.vwingist.com/melscn/0image/2025/04/4639732916975012499.jpg",
          title: "彈力賦活抗皺精華液",
          titKey: "product2",
          subTitle: "",
          txt: "「VESCOR魔法1+1」，深層滲透，彈力活化<br>抗氧+抗醣雙重功效。 ",
          txtKey: "product2Desc",
          des: "",
          link: "/ProductDetailPage/detail4",
        },
        {
          image:
            "https://upload.vwingist.com/melscn/0image/2025/04/5244379572175165070.jpg",
          title: "彈力賦活抗皺精華霜",
          titKey: "product3",
          subTitle: "",
          txt: "「VESCOR魔法1+1」，定格裸感美肌<br/>鎖鮮防護，持久保濕。",
          txtKey: "product3Desc",
          des: "",
          link: "/ProductDetailPage/detail5",
        },
        {
          image:
            "https://upload.vwingist.com/melscn/0image/2025/04/5384676399849469183.jpg",
          title: "膠原蛋白蜜肌面膜",
          titKey: "product4",
          subTitle: "",
          txt: "富含的膠原蛋白，是肌膚保持年輕的祕密。",
          txtKey: "product4Desc",
          des: "",
          link: "/ProductDetailPage/detail1",
        },
        {
          image:
            "https://upload.vwingist.com/melscn/0image/2025/04/5710599352746727144.jpg",
          title: "黑鑽至臻炭煥顏面膜",
          titKey: "product5",
          subTitle: "",
          txt: "備長炭的奇妙加持，讓肌膚喝飽水。",
          txtKey: "product5Desc",
          des: "",
          link: "/ProductDetailPage/detail2",
        },

        {
          image:
            "https://upload.vwingist.com/melscn/0image/2025/04/4990238919937414802.jpg",
          title: "賦顏菁萃精華油",
          titKey: "product6",
          subTitle: "",
          txt: "角鯊烷以油養膚，解鎖凍齡肌密",
          txtKey: "product6Desc",
          des: "",
          link: "/ProductDetailPage/detail6",
        },
        {
          image:
            "https://upload.vwingist.com/melscn/0image/2025/04/5621361634882745281.jpg",
          title: "柔光水潤粉底液",
          titKey: "product7",
          subTitle: "",
          txt: "山茶籽油的神奇力量，輕鬆打造自然裸妝。",
          txtKey: "product7Desc",
          des: "",
          link: "/ProductDetailPage/detail7",
        },
      ],
    };
  },
  mounted() {},
  methods: {
    handleSizeChange() {},
    handleCurrentChange() {},
    handleGo(url) {
      this.$router.push(url);
    },
  },
};
</script>
<style lang="less">
.home-page {
  .image-container {
    display: inline-block; /* 确保容器只占用图片的空间 */
    overflow: hidden; /* 隐藏超出容器的部分 */
  }
  .zoomable-image {
    transition: transform 0.3s ease; /* 添加过渡效果，使放大过程更平滑 */
  }
  img {
    width: 100%;
  }
  .title {
    font-size: 40px;
    color: #333333;
    .mark {
      width: 6px;
      height: 6px;
      background: #4f4f4f;
      border-radius: 50%;
      display: inline-block;
      margin: 0 10px;
    }
    .txt {
      font-size: 26px;
      margin-left: 20px;
    }
  }
  .main_content {
    align-items: flex-start;
    .title {
      font-size: 36px;
      color: #000000;
      align-items: flex-end;
      p {
        &:last-child {
          font-size: 26px;
          text-align: right;
          margin-top: 9px;
        }
      }
    }
    .txt {
      font-size: 18px;
      color: #000000;
      margin: 25px auto 52px;
      p {
        line-height: 27px;
        margin-bottom: 25px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    .more {
      font-size: 26px;
      color: #999999;
      cursor: pointer;
      span {
        color: #333333;
      }
    }
  }

  .banner {
    position: relative;
    .swiper-container {
      .bg {
        // background: url(../assets/images/banner02_01.jpg) no-repeat center;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        width: 1920px;
        height: 900px;
        cursor: pointer;
      }
    }
    .swiper-pagination {
      position: absolute;
      bottom: 60px;
      left: 0;
      right: 0;
      .swiper-pagination-bullet {
        width: 230px;
        height: 2px;
        background: #a9a9a9;
        border-radius: 0;
        opacity: 1;
        margin-right: 3px;
        &:last-child {
          margin-right: 0;
        }
        &.swiper-pagination-bullet-active {
          background: #fff;
        }
      }
    }
  }
  .story_wrap {
    padding: 132px 400px 160px;
    box-sizing: border-box;
    .logo {
      width: 230px;
      margin-right: 90px;
      flex-shrink: 0;
      cursor: pointer;
      img {
        &:hover {
          transform: scale(1.07); /* 鼠标悬停时放大图片 */
        }
      }
    }
  }
  .column_one {
    align-items: flex-start;
    .img {
      width: 930px;
      flex-shrink: 0;
      margin-right: 50px;
      cursor: pointer;
      img {
        &:hover {
          transform: scale(1.07); /* 鼠标悬停时放大图片 */
        }
      }
    }
    .main_content {
      flex: 1;
      align-items: flex-start;
      padding: 88px 405px 0 0;
      box-sizing: border-box;
    }
  }
  .column_two {
    padding: 170px 0 230px;
    box-sizing: border-box;
    align-items: flex-start;
    .item {
      width: 430px;
      flex-shrink: 0;
      align-items: flex-start;
      &:nth-child(2) {
        margin: 0 35px;
      }
      .thumb {
        width: 100%;
        height: 660px;
        cursor: pointer;
        img {
          &:hover {
            transform: scale(1.07); /* 鼠标悬停时放大图片 */
          }
        }
      }
      .content {
        color: #000000;
        .txt {
          font-size: 36px;
          margin: 30px 0 33px;
        }
        p {
          font-size: 20px;
          line-height: 27px;
        }
      }
    }
  }
  .column_three {
    height: 600px;
    align-items: flex-start;
    .img {
      width: 930px;
      height: 100%;
      flex-shrink: 0;
      img {
        &:hover {
          transform: scale(1.07); /* 鼠标悬停时放大图片 */
        }
      }
    }
    .main_content {
      flex: 1;
      padding: 86px 176px 0 280px;
      align-items: flex-start;
      box-sizing: border-box;
      .title {
        align-items: flex-start;
      }
      .txt {
        p {
          line-height: 27px;
          &:nth-child(2) {
            margin: 20px 0 28px;
          }
          &:last-child {
            font-size: 36px;
          }
        }
      }
    }
  }
  .product_wrap {
    .title {
      color: #000000;
      margin-bottom: 60px;
      .txt1 {
        font-size: 36px;
      }
      .txt2 {
        font-size: 26px;
        margin: 18px auto 9px;
      }
      .txt3 {
        font-size: 30px;
      }
    }
    .product-swiper-container {
      padding: 0 278px;
      box-sizing: border-box;
      position: relative;
      margin: 90px auto 170px;
      .swiper-wrap {
        width: 100%;
        .swiper-slide {
          .thumb {
            width: 100%;
            height: 660px;
            cursor: pointer;
            img {
              &:hover {
                transform: scale(1.07); /* 鼠标悬停时放大图片 */
              }
            }
          }
          .main {
            .content {
              font-size: 20px;
              min-height: 150px;
              .title {
                font-size: 32px;
                align-items: flex-start;
                margin: 35px 0 25px;
                p {
                  &:last-child {
                    font-size: 20px;
                    margin-top: 9px;
                  }
                }
              }
              .txt {
                line-height: 26px;
                // margin-bottom: 30px;
              }
              .des {
                line-height: 27px;
              }
            }
            .more {
              font-size: 20px;
              text-align: center;
              line-height: 50px;
              height: 50px;
              background: #e9e9e9;
              cursor: pointer;
              margin-top: 45px;
              display: inline-block;
              padding: 0 30px;
              &:hover {
                background: #333333;
                color: #fff;
              }
            }
          }
        }
      }

      .swiper-button-next {
        right: 119px;
        background-image: url("../assets/images/arrow_right.png");
        width: 31px;
        height: 60px;
        background-size: cover;
      }
      .swiper-button-prev {
        left: 119px;
        background-image: url("../assets/images/arrow_left.png");
        width: 31px;
        height: 60px;
        background-size: cover;
      }

      // .swiper-slide-duplicate-next,
      // .swiper-slide-duplicate-prev {
      //   opacity: 0.5;
      // }
      // .swiper-slide-duplicate-next .content,
      // .swiper-slide-duplicate-prev .content {
      //   opacity: 0;
      // }
    }
  }
  .join_wrap {
    position: relative;
    margin-bottom: 127px;
    background: url("https://upload.vwingist.com/melscn/0image/2025/04/5175367247852106837.png")
      no-repeat center;
    background-size: cover;
    width: 100%;
    height: 750px;
    padding: 120px 0 0 279px;
    box-sizing: border-box;
    .content {
      width: 695px;
      align-items: flex-start;
      .title {
        color: #000000;
        .txt1 {
          font-size: 60px;
        }
        .txt2 {
          font-size: 36px;
          margin: 5px 0;
        }
        .txt3 {
          font-size: 50px;
        }
      }
      .txt {
        margin: 50px 0 40px;
        font-size: 20px;
        p {
          line-height: 27px;
          &:last-child {
            margin-top: 10px;
          }
        }
      }
      .more {
        font-size: 20px;
        text-align: center;
        line-height: 50px;
        height: 50px;
        background: #e9e9e9;
        font-size: 20px;
        cursor: pointer;
        padding: 0 30px;
        box-sizing: border-box;
        &:hover {
          background: #333333;
          color: #fff;
        }
      }
    }
  }
}
</style>